/* global FWP, jQuery */

import $ from 'jquery';
import Select2 from 'select2';

class Filters {
    constructor () {
        this.$document      = $(document);
        this.$resultsText   = $('.js-results-text');
        this.$seachTerm     = $('.js-search-term');
        this.$submit        = $('.js-filters-submit');
        this.$clear         = $('.js-filters-clear');
        this.$sorterButtons = $('.js-sorter-button');

        // Init FacetWP Listeners
        this.initListeners();

        // Search Field Events
        this.$document.on('keydown', '.facetwp-type-search .facetwp-search', $.proxy(Filters.inputSubmit, this));
        this.$document.on('click', '.facetwp-type-search .facetwp-btn', $.proxy(Filters.refreshFWP, this));
        this.$document.on('change', '.facetwp-sort-select', $.proxy(Filters.refreshFWP, this));

        // Button Events
        this.$submit.on('click', $.proxy(Filters.refreshFWP, this));
        this.$clear.on('click', $.proxy(Filters.resetFWP, this));
        this.$sorterButtons.on('click', $.proxy(this.sorterChange, this));

        $(window).on('load', () => {
            // Disable filter auto submit (i.e. users have to click the buttons to update filters)
            Filters.disableAutoSubmit();

            // Update the search text
            this.updateSearchTerm();

            // change the clear button text on pages that have search box
            if (Filters.hasSearchBox()) {
                this.$clear.text('Clear search and filters');
            }
        });
    }

    /**
     * FacetWP Events
     */
    initListeners () {
        // After refresh
        // - Don't use $ to access jQuery, we want the global jQuery
        jQuery(document).on('facetwp-loaded', () => {
            // Make sure dropdowns are made fancy after a refresh
            Filters.initFancyDropdowns();

            // Keep the search term up to date
            this.updateSearchTerm();

            // Set the active sorter button
            this.updateActiveSortButton();

            // Toggle available buttons
            this.toggleAvailableButtons();
        });
    }

    static initFancyDropdowns () {
        new Select2();

        $('.facetwp-yearly').select2({
            minimumResultsForSearch : -1,
            width                   : '100%'
        });
    }

    /**
     * Don't automatically submit filters on change
     * - User has to press the submit button!
     */
    static disableAutoSubmit () {
        if (typeof FWP !== 'undefined') {
            FWP.auto_refresh = false;
        }
    }

    /**
     * Update FacetWP to "submit" the current filter selections
     */
    static refreshFWP () {
        if (typeof FWP !== 'undefined') {
            FWP.refresh();
        }
    }

    /**
     * Clear all FacetWP filters
     */
    static resetFWP () {
        if (typeof FWP !== 'undefined') {
            FWP.reset();
        }
    }

    /**
     * On keydown of enter, "submit" the filters
     */
    static inputSubmit (e) {
        if (e.keyCode === 13) {
            Filters.refreshFWP();
        }
    }

    /**
     * On sorter button click, update the sorter dropdown and refresh FWP
     * @param e
     */
    sorterChange (e) {
        const $elem = $(e.currentTarget);

        // Update the sorter selection (even though it's hidden)
        $('.facetwp-sort-select').val($elem.data('sort'));

        // Update the sorter value in FWP
        if (typeof FWP !== 'undefined') {
            FWP.extras.sort = $elem.data('sort');
        }

        // Update the active button
        this.updateActiveSortButton();

        // Refresh FWP
        Filters.refreshFWP();
    }

    /**
     * Update the search term in the "Showing results for 'XXX'" string.
     */
    updateSearchTerm () {
        if (typeof FWP !== 'undefined') {
            if (typeof FWP.facets.search !== 'undefined' && FWP.facets.search.length) {
                this.$resultsText.show();
                this.$seachTerm.text(FWP.facets.search);
            } else {
                this.$resultsText.hide();
            }
        }
    }

    /**
     * Update the .active sorter button
     */
    updateActiveSortButton () {
        const sortValue     = $('.facetwp-sort-select').val();
        const $activeSorter = this.$sorterButtons.filter(`[data-sort="${sortValue}"]`);

        // Remove active class from other buttons
        this.$sorterButtons.not($activeSorter).removeClass('active');

        if ($activeSorter.length) {
            // Add active class to active button
            $activeSorter.addClass('active');
        } else if (!this.$seachTerm.text().length) {
            // If there is no search term (which would use relevance sorting)
            // - Select the first filter
            this.$sorterButtons.first().addClass('active');
        }
    }

    /**
     * Return whether or not there are any filters or search strings present on the page.
     */
    static hasAnySearchTermsPresent () {
        if (FWP && FWP.facets) {
            for (const facetArrayKey in FWP.facets) {
                if (FWP.facets[facetArrayKey].length) {
                    return true;
                }
            }
        }

        return false;
    }

    /**
     * Check if the current page has a search box
     */
    static hasSearchBox () {
        if (typeof FWP !== 'undefined') {
            return FWP && FWP.facets && FWP && FWP.facets.search;
        }

        return false;
    }

    /**
     * Disables the "clear search and filters" button
     */
    toggleAvailableButtons () {
        // disable reset filter button if no filters are present
        if (Filters.hasAnySearchTermsPresent()) {
            this.$clear.removeAttr('disabled');
        } else {
            this.$clear.attr('disabled', 'disabled');
        }
    }
}

export default Filters;
